<template>
  <drawer-articoli v-if="isArticoli || isNewArticolo" />
  <drawer-clienti v-else-if="isClienti || isNewClifor || isEditClifor" />
  <drawer-movimenti v-else-if="isMovimenti" />
  <drawer-documenti v-else-if="isDocumenti" />
  <drawer-documenti-dettaglio v-else-if="isDocumentiDettaglio" />
</template>

<script>
import DrawerArticoli from '@/views/articoli/drawerArticoli'
import DrawerClienti from '@/views/clienti/drawerClienti'
import DrawerMovimenti from '@/views/movimenti/drawerMovimenti'
import DrawerDocumenti from '@/views/documenti/drawerDocumenti'
import DrawerDocumentiDettaglio from '@/views/documenti/drawerDocumentiDettaglio'

export default {
  components: {
    DrawerArticoli,
    DrawerClienti,
    DrawerMovimenti,
    DrawerDocumenti,
    DrawerDocumentiDettaglio
  },
  data: () => ({
  }),
  computed: {
    pagina() {
      return this.$route.name
    },
    isArticoli() {
      return this.pagina === 'Articoli'
    },
    isArticoliOrDocumenti() {
      console.log('pagina', this.pagina)
      return this.isArticoli || this.isNewArticolo || this.isDocumenti
    },
    isClienti() {
      return this.pagina === 'Clienti'
    },
    isMovimenti() {
      return this.pagina === 'Movimenti'
    },
    documentoPage() {
      return this.$store.getters['documenti/page']
    },
    isDocumenti() {
      return this.pagina === 'Documenti'  && this.documentoPage === 'testata'
    },
    isDocumentiDettaglio() {
      return this.pagina === 'Documenti' && this.documentoPage === 'dettaglio'
    },
    isNewArticolo() {
      return this.$store.getters['movimenti/creaArticolo']
    },
    isNewClifor() {
      console.log('isNewClifor', this.$store.getters['clienti/creaClifor'])
      return this.$store.getters['clienti/creaClifor']
    },
    isEditClifor() {
      console.log('isEditClifor', this.$store.getters['clienti/editClifor'])
      return this.$store.getters['clienti/editClifor']
    },
    isDocumentiFornitore() {
      console.log('isDocumentiFornitore', this.pagina, this.documentoPage)
      return this.pagina === 'Ordini fornitore'
    }
  }
}
</script>
